// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Ie0c","upload":"Small_upload__12Q-l","imageWrap":"Small_imageWrap__3w5PV","removeBtn":"Small_removeBtn__KlLO0"};